import React, { useEffect, useState, createContext } from 'react';

const isOutdated = (timestamp) => {
  const oneWeek = 7 * 24 * 60 * 60 * 1000;
  const now = new Date().getTime();
  return now - timestamp > oneWeek;
};

// Create a Context to optionally provide data to children
export const SunulifeContentContext = createContext(null);

export const SunulifeContentProvider = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const initializeData = async () => {
      const sunulifeContent = localStorage.getItem('SunulifeContent');
      const timestamp = localStorage.getItem('SunulifeContentTimestamp');

      if (!sunulifeContent || !timestamp || isOutdated(timestamp)) {
        try {
          const response = await fetch('https://on.sunulife.com/sunulife-content-api');
          const data = await response.json();
          localStorage.setItem('SunulifeContent', JSON.stringify(data));
          localStorage.setItem('SunulifeContentTimestamp', new Date().getTime().toString());
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
      setIsLoaded(true); // Data is ready
    };

    initializeData();
  }, []);

  // Delay rendering children until data is initialized
  if (!isLoaded) return null;

  // Wrap children in the Context Provider (optional if children need direct access to data)
  return (
    <SunulifeContentContext.Provider value={JSON.parse(localStorage.getItem('SunulifeContent'))}>
      {children}
    </SunulifeContentContext.Provider>
  );
};
